import lodash from 'lodash'
import React, { useEffect, useState } from 'react'

import LoaderOverlay from '../../../1stlog-ui/src/components/LoaderOverlay'
import { getBrowserLanguage, request } from '../../../1stlog-ui/src/utils'
import SettingsContext from './SettingsContext'

const SettingsContextProvider = (props) => {
  const {
    initialSettings = {},
    defaultLocalSettings = {},
    children = null,
    ignoreLanguage = false,
  } = props

  const [isLoading, setIsLoading] = useState(false)

  const [settings, setSettings] = useState()

  const [localSettingsKeys] = useState(lodash.keys(defaultLocalSettings))

  useEffect(() => {
    const initialLocalSettings = readLocalSettings(defaultLocalSettings)
    if (!ignoreLanguage) {
      i18n.on('languageChanged', onLanguageChanged)
    }

    setSettings(() => {
      if (!ignoreLanguage && !lodash.get(initialSettings, 'language')) {
        const browserLanguage = getBrowserLanguage()
        updateSetting('language', browserLanguage)
      }

      const newSettings = {
        ...initialLocalSettings,
        ...initialSettings,
      }

      if (!ignoreLanguage) {
        onLanguageChanged(lodash.get(newSettings, 'language'))
      }

      return newSettings
    })
  }, [])

  const onLanguageChanged = (lng) => {
    updateSetting('language', lng)
  }

  const updateSetting = async (name, value) => {
    if (lodash.get(settings, name) !== value) {
      await updateSettings({ [name]: value })
    }
  }

  const updateSettings = async (newSettings = {}) => {
    // update local settings
    const localData = lodash.pickBy(
      lodash.pick(newSettings, localSettingsKeys),
      (value, key) => {
        return !lodash.isEqual(value, lodash.get(settings, key))
      },
    )
    if (!lodash.isEmpty(localData)) {
      const newLocalSettings = {
        ...lodash.pick(settings, localSettingsKeys),
        ...localData,
      }
      writeLocalSettings(newLocalSettings)
    }

    // update server settings
    const data = lodash.pickBy(
      lodash.omit(newSettings, localSettingsKeys),
      (value, key) => {
        return !lodash.isEqual(value, lodash.get(settings, key))
      },
    )
    if (!lodash.isEmpty(data)) {
      try {
        setIsLoading(true)
        await request({
          method: 'post',
          url: `/api/settings`,
          data,
        })
      } catch (error) {
        console.error('SettingsContextProvider update failed', error)
      } finally {
        setIsLoading(false)
      }
    }

    if (!lodash.isEmpty(localData) || !lodash.isEmpty(data)) {
      setSettings((prevSettings) => ({
        ...prevSettings,
        ...localData,
        ...data,
      }))
    }
  }

  return (
    <SettingsContext.Provider
      value={{ settings, updateSetting, updateSettings }}
    >
      <>
        <LoaderOverlay isLoading={isLoading}>
          {i18n.t('loading_settings', 'Einstellungen werden geladen')}
        </LoaderOverlay>
        {children}
      </>
    </SettingsContext.Provider>
  )
}

export default SettingsContextProvider

function readLocalSettings(initialLocalSettings = {}) {
  let settings = {}
  try {
    settings = JSON.parse(window.localStorage.getItem('settings')) || {}
  } catch (err) {}
  const result = {
    ...initialLocalSettings,
    ...settings,
  }
  return result
}

function writeLocalSettings(settings) {
  window.localStorage.setItem('settings', JSON.stringify(settings))
}
